/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input} from '@angular/core';
import {SubscriptionsListService} from "./subscriptions-list.service";
import {Observable} from "rxjs";
import { JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';

@Component({
  selector: 'well-subscriptions-list',
  templateUrl: './subscriptions-list.component.html',
  styleUrls: ['./subscriptions-list.component.scss']
})
export class SubscriptionsListComponent {

  legalEntities: Observable<JsonApiResource<LegalEntityModel[], JsonApiListResourceMetadataBase>> | undefined = undefined;

  private _subscriptionTypeUuid: string | undefined = undefined;

  get subscriptionTypeUuid(): string | undefined{
    return this._subscriptionTypeUuid;
  }

  @Input() set subscriptionTypeUuid(value: string) {
    this._subscriptionTypeUuid = value;
    this.legalEntities = this.subscriptionsListService.getLegalEntitiesForSubscriptionType(this._subscriptionTypeUuid)

  }

  constructor(private subscriptionsListService: SubscriptionsListService) {
  }

  update() {
    if(this._subscriptionTypeUuid) {
      this.legalEntities = this.subscriptionsListService.getLegalEntitiesForSubscriptionType(this._subscriptionTypeUuid)
    }
  }
}
